import { render, staticRenderFns } from "./afil.vue?vue&type=template&id=9dcfd972&scoped=true&"
import script from "./afil.vue?vue&type=script&lang=js&"
export * from "./afil.vue?vue&type=script&lang=js&"
import style0 from "./afil.vue?vue&type=style&index=0&id=9dcfd972&scoped=true&lang=css&"
import style1 from "./afil.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcfd972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dcfd972')) {
      api.createRecord('9dcfd972', component.options)
    } else {
      api.reload('9dcfd972', component.options)
    }
    module.hot.accept("./afil.vue?vue&type=template&id=9dcfd972&scoped=true&", function () {
      api.rerender('9dcfd972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/afil/afil.vue"
export default component.exports